/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { GetLinkedOrganizationsResponse } from '../../models/get-linked-organizations-response';

export interface GetLinkedOrganizations$Params {
  companyId: string;
}

export function getLinkedOrganizations(http: HttpClient, rootUrl: string, params: GetLinkedOrganizations$Params, context?: HttpContext): Observable<StrictHttpResponse<GetLinkedOrganizationsResponse>> {
  const rb = new RequestBuilder(rootUrl, getLinkedOrganizations.PATH, 'get');
  if (params) {
    rb.path('companyId', params.companyId, {});
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<GetLinkedOrganizationsResponse>;
    })
  );
}

getLinkedOrganizations.PATH = '/api/v1/companies/{companyId}';
